module.exports = __webpack_public_path__ + "media/intro_hochkant.849a4b17.webm";